module.exports = __webpack_public_path__ + "img/ArmadoTodosLosGrupos.1e0b758e.svg";